<template>
  <div class="tab-area">
    <el-tabs v-model="activeArea" @tab-click="handleAreaClick" :stretch="true">
      <el-tab-pane v-for="area in tabs" :key="JSON.stringify(area)" :label="area.name" :name="area.name">
        <el-tabs v-model="activeDate" :stretch="true" @tab-click="handleDateClick" :v-if="activeDate">
          <el-tab-pane v-for="date in area.dates" :key="JSON.stringify(date)" :label="date.name" :name="date.name">
          </el-tab-pane>
        </el-tabs>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  name: 'Tabs',
  props: {
    tabs: []
  },
  data () {
    return {
      activeArea: null,
      activeDate: null,
      beforeAreaTab: null
    }
  },
  mounted () {
    this.activeArea = 'SONICMANIA'
    this.beforeAreaTab = this.activeArea
  },
  methods: {
    handleAreaClick (tab, event) {
      if (this.beforeAreaTab !== tab.paneName) {
        const selectArea = this.tabs.find((tabData) => {
          return (tabData.name === tab.paneName)
        })
        if (selectArea.dates) {
          this.activeDate = selectArea.dates[Object.keys(selectArea.dates)[0]].name
        } else {
          this.activeDate = null
        }
        this.beforeAreaTab = tab.paneName
      }
      this.sendTabDataParent()
    },
    handleDateClick (tab, event) {
      this.activeDate = tab.paneName
      this.sendTabDataParent()
    },
    sendTabDataParent () {
      this.$parent.activeArea = this.beforeAreaTab
      this.$parent.activeDate = this.activeDate
    }
  }
}
</script>

<style lang="scss">
@import "../../assets/css/components/parts/Tabs";
</style>



// WEBPACK FOOTER //
// src/components/parts/Tabs.vue